import { render, staticRenderFns } from "./image-picker.editor.vue?vue&type=template&id=079d489c&"
import script from "./image-picker.editor.vue?vue&type=script&lang=ts&"
export * from "./image-picker.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports